import type { ReactNode } from 'react'
import styles from './Panel.module.css'

interface PanelProps {
  title?: string
  note?: string
  actions?: ReactNode
  children?: ReactNode
  /** Доп. класс карточки: у графика в макете нет левого отступа. */
  className?: string | undefined
}

/** Карточка раздела: заголовок, подпись, действия справа, содержимое. */
export function Panel({ title, note, actions, children, className }: PanelProps) {
  return (
    <section className={className ? `${styles.panel} ${className}` : styles.panel}>
      {title || actions ? (
        <header className={styles.head}>
          <div className={styles.titles}>
            {title ? <h2 className={styles.title}>{title}</h2> : null}
            {note ? <span className={styles.note}>{note}</span> : null}
          </div>
          {actions ? <div className={styles.actions}>{actions}</div> : null}
        </header>
      ) : null}
      {children}
    </section>
  )
}

interface EmptyProps {
  title: string
  note?: string
  action?: ReactNode
}

/** Пустой список: что здесь появится и что для этого сделать. */
export function Empty({ title, note, action }: EmptyProps) {
  return (
    <div className={styles.empty}>
      <span className={styles.emptyTitle}>{title}</span>
      {note ? <span className={styles.emptyNote}>{note}</span> : null}
      {action ? <div className={styles.emptyAction}>{action}</div> : null}
    </div>
  )
}
